module.exports = __webpack_public_path__ + "static/media/loaded_active.b8524c36.svg";